<template>
  <LayoutSite>
    <Formulario titulo="Configurações do Escritório" v-if="!frmcadastro">
      <v-card-title>
        <v-btn
          color="primary"
          dark
          class="mb-2"
          @click="openform('novo')"
          :disabled="!permissoes.configescritorio_incluir"
        >Nova Configuração</v-btn>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        v-model="selected"
        locale="pt-BR"
      >
        <template v-slot:item="props">
          <tr @dblclick="openform('editar',props.item.id)">
            <td class="text-xs-right">{{ props.item.escritorio }}</td>
            <td class="text-xs-right">{{props.item.catalogo }}</td>
          </tr>
        </template>
        <v-alert
          slot="no-results"
          :value="true"
          color="error"
          icon="warning"
        >Sua Pesquisa por "{{ search }}" não encontrou registros.</v-alert>
      </v-data-table>
    </Formulario>
    <Formulario :titulo="titulo" v-if="frmcadastro">
      <v-form @submit.prevent="salvar()">
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="frmcadastro=false; getData();">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row justify="center">
            <v-col cols="6">
              <v-autocomplete
                label="Escritório"
                v-model="configescritorio.escritorio_id"
                :items="escritorios"
                item-text="nome"
                item-value="id"
              ></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-autocomplete
                label="Catálogo"
                v-model="configescritorio.catalogo_id"
                :items="catalogos"
                item-text="nome"
                item-value="id"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-alert
            dense
            outlined
            type="error"
            v-for="(erro, index) of erros"
            :key="index"
          >{{erro[0]}}</v-alert>
        </v-card-text>
        <v-card-actions>
          <v-btn
            depressed
            color="error"
            @click="confirmaExcluir()"
            v-if="excluir"
            :disabled="!permissoes.configescritorio_excluir"
          >EXCLUIR</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            color="primary"
            type="submit"
            :disabled="!permissoes.configescritorio_alterar"
          >SALVAR</v-btn>
        </v-card-actions>
        <template>
          <v-row justify="center">
            <v-dialog v-model="exclusao" persistent max-width="400">
              <v-card>
                <v-card-title class="headline">Atenção</v-card-title>
                <v-card-text>Deseja realmente excluir esta Configuração?</v-card-text>
                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn color="red darken-1" text @click="exclusao = false">NÃO</v-btn>

                  <v-btn color="blue darken-1" text @click="deletar()">SIM</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
        </template>
      </v-form>
    </Formulario>
  </LayoutSite>
</template>

<script>
import LayoutSite from "@/components/layout/LayoutSite";
import Formulario from "@/components/Form";

export default {
  components: {
    LayoutSite,
    Formulario,
  },
  data() {
    return {
      selected: [],
      search: "",
      headers: [
        { text: "Escritório", value: "escritorio", align: "left" },
        { text: "Catálogo", value: "catalogo" },
      ],
      items: [],
      frmcadastro: false,
      excluir: false,
      exclusao: false,
      readonly: true,
      titulo: String,
      erros: [],
      escritorios: [],
      catalogos: [],
      configescritorio: {
        id: 0,
        escritorio_id: 0,
        catalogo_id: 0,
      },
      permissoes: {
        configescritorio: false,
        configescritorio_incluir: false,
        configescritorio_alterar: false,
        configescritorio_excluir: false,
      },
    };
  },
  created: function () {
    this.getData();

    let permAux = this.$store.getters.getPermissoes;

    if (permAux.ativo) {
      this.permissoes = permAux;
      if (!this.permissoes.catalogo) this.$router.push("/#");
    } else this.$router.push("/#");
  },
  methods: {
    getData: function () {
      this.$http
        .get(this.$urlAPI + "/configescritorio", {
          headers: { authorization: "Bearer " + this.$store.getters.getToken },
        })
        .then((response) => (this.items = response.data));

      this.$http
        .get(this.$urlAPI + "/escritorio", {
          headers: { authorization: "Bearer " + this.$store.getters.getToken },
        })
        .then((response) => (this.escritorios = response.data));

      this.$http
        .get(this.$urlAPI + "/catalogo", {
          headers: { authorization: "Bearer " + this.$store.getters.getToken },
        })
        .then((response) => (this.catalogos = response.data));
    },
    openform: function (opcao, id) {
      this.frmcadastro = true;
      this.erros = [];
      if (opcao == "novo") {
        this.excluir = false;
        this.titulo = "Nova Configuração de Escritório";
        this.configescritorio.escritorio_id = 0;
        this.configescritorio.catalogo_id = 0;
        this.configescritorio.id = 0;
      } else if (opcao == "editar") {
        this.excluir = true;
        this.titulo = "Editar Configuração de Escritório";
        this.$http
          .get(this.$urlAPI + "/configescritorio/" + id, {
            headers: {
              authorization: "Bearer " + this.$store.getters.getToken,
            },
          })
          .then((response) => {
            this.configescritorio = response.data;
          });
      }
    },
    salvar: function () {
      if (this.excluir) {
        this.$http
          .post(
            this.$urlAPI + "/configescritorio/" + this.configescritorio.id,
            this.configescritorio,
            {
              headers: {
                authorization: "Bearer " + this.$store.getters.getToken,
              },
            }
          )
          .then((response) => {
            if (response.data.status) {
              this.frmcadastro = false;
              this.getData();
            } else {
              this.erros = null;
              this.erros = response.data.erros;
            }
          })
          .catch((e) => {
            this.erros = e.response.data.erros;
          });
      } else {
        this.$http
          .post(this.$urlAPI + "/configescritorio", this.configescritorio, {
            headers: {
              authorization: "Bearer " + this.$store.getters.getToken,
            },
          })
          .then((response) => {
            if (response.data.status) {
              this.frmcadastro = false;
              this.getData();
            } else {
              this.erros = null;
              this.erros = response.data.erros;
            }
          })
          .catch((e) => {
            this.erros = e.response.data.erros;
          });
      }
    },
    confirmaExcluir: function () {
      this.exclusao = true;
    },
    deletar: function () {
      this.$http
        .delete(
          this.$urlAPI + "/configescritorio/" + this.configescritorio.id,
          {
            headers: {
              authorization: "Bearer " + this.$store.getters.getToken,
            },
          }
        )
        .then((response) => {
          if (response.data.status) {
            this.frmcadastro = false;
            this.exclusao = false;
            this.getData();
          } else {
            this.erros = null;
            this.erros = response.data.erros;
          }
        })
        .catch((e) => {
          this.erros = e.response.data.erros;
        });
    },
  },
};
</script>
